module.exports = __webpack_public_path__ + "img/制御工学5_5.a2cfa98d.png";